var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useEffect, useState } from 'react';
import { translate, useToastService } from '@lucidlink/uicore';
import { usePlugFilespaceClient } from '#query-hooks';
// TODO: https://lucidlink.atlassian.net/browse/LUCID-25505
export const useFilespaceClientStatus = ({ filespaceId, onError, workspaceId, }) => {
    _react_refresh_temp_1();
    const [isFilespaceLogIn, setIsFilespaceLogIn] = useState(true);
    const [isErrorFilespaceLogIn, setIsErrorFilespaceLogIn] = useState(false);
    const { addToast } = useToastService();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const initFilespaceClient = useCallback(async () => {
        try {
            await plugFilespaceClient({
                action: () => Promise.resolve(),
                filespaceId,
                workspaceId,
            });
        }
        catch (error) {
            addToast({
                content: {
                    message: translate('Failed to establish connection to filespace. Please try again later.'),
                },
                kind: 'negative',
                'data-testid': 'error-filespace-login-failed',
            });
            if (onError) {
                void onError();
            }
            setIsErrorFilespaceLogIn(true);
        }
        finally {
            setIsFilespaceLogIn(false);
        }
    }, [addToast, filespaceId, onError, plugFilespaceClient, workspaceId]);
    useEffect(() => {
        void initFilespaceClient();
    }, [initFilespaceClient]);
    return { isErrorFilespaceLogIn, isFilespaceLogIn };
};
_react_refresh_temp_1(useFilespaceClientStatus, "mbveS2Lt9w3yaX/M0OWNde7vZEI=", false, () => [useToastService, usePlugFilespaceClient]);
